export default function CtaSection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20inviting%20curated%20fashion%20collection%20display%20with%20neatly%20arranged%20clothing%20and%20accessories%20on%20light%20wooden%20shelving%2C%20cream%20and%20warm%20beige%20color%20palette%20with%20soft%20sage%20green%20touches%2C%20soft%20diffused%20natural%20lighting%20from%20large%20windows%2C%20minimalist%20boutique%20aesthetic%20with%20organic%20linen%20textures%2C%20cozy%20shopping%20atmosphere%2C%20lifestyle%20product%20photography%2C%20clean%20and%20airy%20composition%20with%20depth&width=1600&height=700&seq=cta-bg-v2&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 leading-tight">
          Ready To Find Your Next Product?
        </h2>
        <p className="text-sm md:text-lg text-background-200/90 max-w-xl mx-auto mb-10">
          Thousands of curated products are waiting. Start exploring the Sugargoo Spreadsheet today and discover amazing finds across every category.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            Start Exploring Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-medium hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}